module.exports = __webpack_public_path__ + "img/chadle_adv_26.1aef0765.png";